// ====================================================================
// ziven-core forum modifyDiscussionItem - v0.5.11
// ====================================================================
//
// 帖子列表页卡片改造 (辉哥 9/4 15:13 反馈, 派 Coder 干).
//
// v0.5.11 之前的现状:
//   - 1.8 时代 ziven-dress-up 项目改 ApiSerializer 加 imageCount + imageList attribute
//   - jQuery setInterval 检测 vnode.dom 出现, 注入 <div class='DiscussionListImageThumbnail'> 缩略图块
//   - mobile 模式: 整卡片重组, 把原 vendor DiscussionListItem 内容搬到另一张 mobile card
//
// v0.5.11 改造 (Trello 卡 6a9a75966a9eca6eaba35185, 辉哥 9/4 15:13 拍板):
//   - 缩略图渲染抽到 DiscussionThumbnails.jsx 组件
//   - desktop 模式: extend(DiscussionListItem.prototype, 'mainView') 末尾追加 vnode,
//     mithril 自动 mount, 不再需要 jQuery 轮询 dom 出现
//   - mobile 模式: 保留 jQuery 整卡片重组, 缩略图用 DiscussionThumbnails.renderHtml()
//     静态方法生成 HTML 字符串 (mobile 重组是纯 DOM 注入, 不走 mithril)
//   - 保留 v0.4.x 沉淀的 jQuery mobile 重组模式 (item-excerpt / item-tags / item-title
//     搬到另一张 mobile card, vendor DiscussionListItem main click 转发 等)
//
// 依赖:
//   - ziven-core.window.zivenCore.isMobile() — v0.4.x 沉淀
//   - src/Api/DiscussionAttributes.php — expose imageCount + imageList 给前端
//   - components/DiscussionThumbnails.jsx — 本次新建
// ====================================================================
import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionThumbnails from './components/DiscussionThumbnails';
export default function modifyDiscussionItem() {
  // ── desktop 模式: mithril vnode 渲染缩略图 ────────────────────────────
  // extend(DiscussionListItem.prototype, 'mainView') 末尾追加 vnode, mithril
  // 自动 mount, 不需要 jQuery 轮询. 跟 vendor DiscussionListItem 原生 lifecycle 对齐.
  extend(DiscussionListItem.prototype, 'mainView', function (vnode) {
    const discussion = this.attrs.discussion;
    if (!discussion) return;

    // 在 children 末尾追加缩略图 vnode (mithril 自动 mount, onupdate 走 mithril lifecycle)
    if (!vnode.children) vnode.children = [];
    if (Array.isArray(vnode.children)) {
      vnode.children.push(m(DiscussionThumbnails, {
        discussion
      }));
    } else {
      // 兜底: 非数组 children (vendor 可能直接传 string 或 single vnode)
      vnode.children = [vnode.children, m(DiscussionThumbnails, {
        discussion
      })];
    }
  });

  // ── mobile 模式: jQuery 整卡片重组 (v0.4.x 沉淀, 保留) ──────────────────
  // mobile 整卡片重组是纯 DOM 注入, 不走 mithril 渲染管线. 缩略图用静态
  // DiscussionThumbnails.renderHtml() 拼字符串, 跟 desktop 共用同一份渲染规则.
  extend(DiscussionListItem.prototype, 'mainView', function (vnode) {
    const _this = this;
    if ($(_this).length > 0) {
      let task = setInterval(function () {
        const dom = vnode.dom;
        if (dom) {
          clearInterval(task);
          let discussionContainer = $(dom).parent().parent().parent();
          if (discussionContainer.hasClass("ModifiedDiscussion")) {
            let itemBadges = discussionContainer.find(".DiscussionListItem-badges");
            if (itemBadges.find("li").length > 1) {
              discussionContainer.find(".item-show-options").hide();
            } else {
              discussionContainer.find(".item-show-options").show();
            }
            return;
          }
          discussionContainer.addClass("ModifiedDiscussion");
          const isMobile = window.zivenCore.isMobile();
          const discussion = _this.attrs.discussion;
          const tags = discussion.tags();
          const imageCount = discussion.attribute("imageCount") || 0;
          const imageList = discussion.attribute("imageList") || [];
          const commentCount = discussion.attribute("commentCount") - 1;

          // v0.5.11: 缩略图改用 DiscussionThumbnails.renderHtml 静态方法,
          // 跟 desktop 模式共用同一份渲染规则 (1/2-3/4+ 三档)
          const thumbnailsHtml = isMobile ? '' // mobile 重组时单独注入, 下面处理
          : DiscussionThumbnails.renderHtml(imageList, imageCount);
          if (discussionContainer.find(".item-show-options").length > 0) {
            discussionContainer.find(".item-show-options").remove();
          }
          if (isMobile) {
            const itemExcerpt = discussionContainer.find(".item-excerpt");
            const itemTags = discussionContainer.find(".item-tags");
            const itemTitle = discussionContainer.find(".DiscussionListItem-title");
            const itemReply = discussionContainer.find(".item-terminalPost > span");
            const itemAuthor = discussionContainer.find(".DiscussionListItem-author");
            const itemBadges = discussionContainer.find(".DiscussionListItem-badges");

            // v0.5.11: mobile 模式缩略图独立生成 HTML (跟 desktop 同一份规则)
            const mobileThumbnailsHtml = DiscussionThumbnails.renderHtml(imageList, imageCount);
            discussionContainer.append("<div class='DiscussionListItemMobile'><div class='itemMain'><div class='itemTitle'></div><div class='itemExcerpt'></div><div class='DiscussionListImageThumbnailWrap'>" + mobileThumbnailsHtml + "</div><div class='itemReply'><div class='itemHeaderAvatar'></div></div></div><div class='itemFooter'><div class='info'><i class='fa-solid fa-message'></i>" + commentCount + "</div></div></div>");
            discussionContainer.find(".itemExcerpt").append(itemExcerpt.find(".Synopsis-excerpt").clone());
            discussionContainer.find(".itemFooter").prepend(itemTags.find(".TagsLabel").clone());
            discussionContainer.find(".itemTitle").append(itemTitle.text());
            // discussionContainer.find(".itemBadges").append(itemBadges.clone());

            let badgeOptionStyle = "";
            if (itemBadges.find("li").length > 0) {
              badgeOptionStyle = "display:none";
            }
            itemBadges.append('<li style="' + badgeOptionStyle + '" class="item-show-options"><div class="Badge Badge--stickiest text-contrast--unchanged"><i class="fa-solid fa-ellipsis"></i></div></li>');
            itemBadges.on("click", function () {
              setTimeout(function () {
                discussionContainer.find("button.Dropdown-toggle").click();
              }, 100);
            });
            discussionContainer.find(".itemTitle").on("click", function () {
              discussionContainer.find(".DiscussionListItem-main")[0].click();
            });
            discussionContainer.find(".itemExcerpt").on("click", function () {
              discussionContainer.find(".DiscussionListItem-main")[0].click();
            });
            if (commentCount === 0) {
              discussionContainer.find(".itemHeaderAvatar").append(itemAuthor.clone());
            } else {
              discussionContainer.find(".itemHeaderAvatar").css("display", "none");
            }
            discussionContainer.find(".itemReply").append(itemReply.clone());

            // itemAuthor.parent().hide();
            itemTitle.remove();
            itemExcerpt.remove();
            itemReply.remove();
            $(".DiscussionListItem-count").remove();
            $(".item-discussion-views").remove();
            itemTags.remove();
            const tagLabels = discussionContainer.find(".itemFooter").find(".TagLabel-name");
            for (let i = 0; i < tagLabels.length; i++) {
              const tagName = tagLabels[i].innerText;
              for (let index in tags) {
                const tag = tags[index];
                if (tag.attribute("name") === tagName) {
                  const tagSlug = tag.attribute("slug");
                  $(tagLabels[i]).parent().parent().on("click", function () {
                    m.route.set(app.route('tag', {
                      tags: tagSlug
                    }));
                  });
                  break;
                }
              }
            }
          } else {
            // desktop 模式: v0.5.11 改由 mithril vnode 渲染, 这里 jQuery 注入保留作为
            // 兜底 (避免 vendor mainView 改造时序错位, mithril vnode 还没 mount 时也显示)
            discussionContainer.append("<div class='DiscussionListImageThumbnailWrap'>" + thumbnailsHtml + "</div>");
          }
        }
      }, 10);
    }
  });
}